export const DELETE_ERROR = 'DELETE_ERROR';
